<template>
	<div class="tw3-flex tw3-justify-center">
		<Form
			v-slot="$form"
			class="tw3-flex tw3-flex-col tw3-gap-4 tw3-w-full sm:w-56"
			:initialValues
			:resolver
			@submit="onFormSubmit"
		>
			<div class="tw3-flex tw3-flex-wrap tw3-items-start tw3-gap-2">
				<div class="tw3-flex tw3-flex-1 tw3-flex-col tw3-gap-1">
					<InputMask
						fluid
						mask="*?*******"
						name="plate"
						placeholder="_ _ _ _ _ _ _ _"
					/>
					<Message
						v-if="$form.plate?.invalid"
						severity="error"
						size="small"
						variant="simple"
					>
						{{ $form.plate.error?.message }}
					</Message>
				</div>

				<div class="tw3-flex tw3-flex-col tw3-gap-1">
					<Select
						fluid
						name="state.value"
						optionLabel="title"
						:options="states"
						placeholder="State"
					/>
					<Message
						v-if="$form.state?.value?.invalid"
						severity="error"
						size="small"
						variant="simple"
					>
						{{ $form.state.value.error?.message }}
					</Message>
					<!-- auto select state based on user/shop/state -->
				</div>

				<div class="tw3-flex tw3-flex-col tw3-gap-1">
					<Button label="Decode Plate" severity="secondary" type="submit" />
				</div>
			</div>
		</Form>
	</div>
</template>

<script setup>
import { Form } from '@primevue/forms';
import { zodResolver } from '@primevue/forms/resolvers/zod';
import Button from 'primevue/button';
import InputMask from 'primevue/inputmask';
import Message from 'primevue/message';
import Select from 'primevue/select';
import { ref } from 'vue';
import { z } from 'zod';

import { US_STATES } from '@/shared/constants';

const emit = defineEmits(['submit']);

const initialValues = ref({
	plate: '',
	state: {
		title: '',
		value: ''
	}
});

const states = ref(US_STATES);

const resolver = ref(
	zodResolver(
		z.object({
			plate: z.string().min(1, { message: 'Plate is required.' }),
			state: z.union([
				z.object({
					value: z.string().min(2, 'State is required.')
				})
			])
		})
	)
);

const onFormSubmit = form => {
	const plate = form.states.plate.value;
	const state = form.states.state.value.value.value;

	if (form.valid) {
		emit('submit', { number: plate, state });
	}
};
</script>
